import Switch from "antd/lib/switch";
import "antd/lib/switch/style/css";

export default Switch;
